export default __webpack_public_path__ + "static/media/carBlack.c3a84acc.svg";